import PropTypes from "prop-types";
import React, { Component } from "react";
// import hydrant from '../fire-hydrant.png';

import {
  Map,
  TileLayer,
  Marker,
  CircleMarker,
  Popup
  // PropTypes as MapPropTypes
} from "react-leaflet";
import L from 'leaflet';
import axios from 'axios'
import MarkerForm from "./markerForm";

// const iconPerson = new L.Icon({
//   iconUrl: require('../fire-hydrant.png'),
//   // iconUrl: require('../svg-1.svg'),
//   iconRetinaUrl: require('../fire-hydrant.png'),
//   iconAnchor: null,
//   popupAnchor: [0, 0],
//   shadowUrl: null,
//   shadowSize: null,
//   shadowAnchor: null,
//   iconSize: new L.Point(20, 20),
//   className: 'leaflet-div-icon',
// });

const iconPerson = new L.divIcon({
    iconAnchor: null,
    popupAnchor: [0, 0],
    shadowUrl: null,
    shadowSize: null,
    shadowAnchor: null,
    iconSize: new L.Point(20, 20),
  className: 'leaflet-div-marker-icon',
});

// const ReactLeaflet = require("react-leaflet");
const handleDrag = (e, callbackFuc) => {
  const latLng = e.target.getLatLng();
  // e.target.openPopup();

  callbackFuc(latLng)
}

const MyPopupMarker = ({ children, position, isDraggable, opacity, callbackFuc, isEditing, formData }) => {
  // icon={iconPerson}
  // return <CircleMarker key={formData.markerData.GlobalID} center={position} radius={6} />
  return <Marker
    position={position}
    draggable={isDraggable}
    icon={iconPerson}
    ondragend={(e) => {
      handleDrag(e, callbackFuc);
    }}
    onclick={() => formData.EditMarker(formData)}
    opacity={opacity}
  >
  </Marker>
};
// MyPopupMarker.propTypes = {
//   children: MapPropTypes.children,
//   position: MapPropTypes.latlng
// };

const MyMarkersList = ({ markers }) => {
  const items = markers.map(({ key, ...props }) => (
    <MyPopupMarker key={key} {...props} />
  ));
  console.log('items', items)
  return <div style={{ display: "none" }}>{items}</div>;
};
MyMarkersList.propTypes = {
  markers: PropTypes.array.isRequired
};

export default class CustomMap extends Component {

  constructor(props) {
    super(props);
    this.mapRef = React.createRef();
    this.state = {
      ...props,
      lat: 32.8105611,
      lng: -98.0974003,
      zoom: 13,
      markers: this.props.markers,
      originalMarkers: this.props.markers,
      isEditingMarker: false
    }
  }

  // componentDS

  componentWillReceiveProps = (nextProps) => {
    const map = this.mapRef.current.leafletElement;
    this.updateMap();
    console.log('bounds', map.getBounds(), nextProps.markers)
    const { markers } = this.state
    let tempMarkers = []
    for (let item of nextProps.markers) {
      tempMarkers.push({
        key: item.GlobalID,
        position: [item.Latitude, item.Longitude],
        // icon: { iconPerson },
        isDraggable: false,
        opacity: 1,
        callbackFuc: this.state.CallBackToParent,
        formData: {
          markerData: item,
          deleteMarker: this.state.deleteMarker.bind(this),
          moveMarker: this.state.moveMarker.bind(this),
          EditMarker: this.state.EditMarker.bind(this),
          submit: this.addMarkerData.bind(this)
        }
        // children: <MarkerForm markerData={item} deleteMarker={this.state.deleteMarker.bind(this)} moveMarker={this.state.moveMarker.bind(this)} EditMarker={this.state.EditMarker.bind(this)} submit={this.addMarkerData.bind(this)}/>
      })
    }
    this.setState({
      addingMarker: nextProps.addingMarker,
      originalMarkers: tempMarkers,
      markers: tempMarkers.filter(m => map.getBounds().contains(m.position)),
      movingMarker: nextProps.movingMarker,
      showFormAndAddMarker: nextProps.showFormAndAddMarker,
      closeAllPopups: nextProps.closeAllPopups,
      isEditingMarker: nextProps.editingData && nextProps.editingData.GlobalID ? true : false
    })
    if ((nextProps.addingMarker && nextProps.editingData)) {
      var index1 = markers.findIndex(x => x.key === nextProps.editingData.GlobalID)
      var tempArray = this.state.markers
      for (var i = 0; i < tempArray.length; i++) {
        tempArray[i] = {
          ...tempArray[i],
          opacity: 0.57
        }
      }
      tempArray[index1] = {
        ...tempArray[index1],
        isDraggable: false,
        opacity: 1,
      }

      this.setState({
        markers: tempArray.filter(m => map.getBounds().contains(m.position)),
        originalMarkers: tempArray
      })
    }
    if (nextProps.movingMarker) {
      var index1 = markers.findIndex(x => x.key === nextProps.editingData.GlobalID)
      var tempArray = this.state.markers
      for (var i = 0; i < tempArray.length; i++) {
        tempArray[i] = {
          ...tempArray[i],
          opacity: 0.57
        }
      }
      tempArray[index1] = {
        ...tempArray[index1],
        isDraggable: true,
        isEditing: true,
        opacity: 1,
        formData: {
          markerData: nextProps.editingData,
          deleteMarker: this.state.deleteMarker.bind(this),
          moveMarker: this.state.moveMarker.bind(this),
          EditMarker: this.state.EditMarker.bind(this),
          submit: this.addMarkerData.bind(this),
          markerLatLng: nextProps.markerLatLng
        }
        // children: <MarkerForm markerData={nextProps.editingData} deleteMarker={this.state.deleteMarker.bind(this)} moveMarker={this.state.moveMarker.bind(this)} EditMarker={this.state.EditMarker.bind(this)} submit={this.addMarkerData.bind(this)} markerLatLng={nextProps.markerLatLng}/>
      }

      this.setState({ markers: tempArray.filter(m => map.getBounds().contains(m.position)), originalMarkers: tempArray })
    }
    if (nextProps.resetMarker) {
      var index1 = markers.findIndex(x => x.key === nextProps.editingData.GlobalID)
      var tempArray = this.state.markers
      for (var i = 0; i < tempArray.length; i++) {
        tempArray[i] = {
          ...tempArray[i],
          opacity: 0.57
        }
      }
      tempArray[index1] = {
        ...tempArray[index1],
        position: [nextProps.editingData.Latitude, nextProps.editingData.Longitude],
        isDraggable: false,
        opacity: 1,
        formData: {
          markerData: nextProps.editingData,
          deleteMarker: this.state.deleteMarker.bind(this),
          moveMarker: this.state.moveMarker.bind(this),
          EditMarker: this.state.EditMarker.bind(this),
          submit: this.addMarkerData.bind(this),
          markerLatLng: nextProps.markerLatLng
        }

        // children: <MarkerForm markerData={nextProps.editingData} deleteMarker={this.state.deleteMarker.bind(this)} moveMarker={this.state.moveMarker.bind(this)} EditMarker={this.state.EditMarker.bind(this)} submit={this.addMarkerData.bind(this)} markerLatLng={nextProps.markerLatLng}/>
      }

      this.setState({ markers: tempArray.filter(m => map.getBounds().contains(m.position)), originalMarkers: tempArray })
    }
    if (nextProps.cancelMarker && tempMarkers.filter(x => x.key === 'newMarker').length !== 0) {
      var index = tempMarkers.findIndex(x => x.key === 'newMarker')
      tempMarkers.splice(index, 1);
      this.setState({
        markers: tempMarkers.filter(m => map.getBounds().contains(m.position)),
        originalMarkers: tempMarkers,
      })
    }
    if (nextProps.cancelMarker) {
      var tempArray2 = markers
      for (var j = 0; j < tempArray2.length; j++) {
        tempArray2[j] = {
          ...tempArray2[j],
          opacity: 1
        }
      }
      //figureOut a way to say save position when cancelled
      this.setState({ markers: tempArray2.filter(m => map.getBounds().contains(m.position)), originalMarkers: tempArray2 })
    }
    if (nextProps.closeAllPopups) {
      this.mapRef.current.leafletElement.closePopup();
    }
  }

  openPopup(marker) {
    if (marker && marker.leafletElement) {
      // window.setTimeout(() => {
      marker.leafletElement.openPopup()
      // })
    }
  }

  addMarker = (e) => {
    const { markers } = this.state
    this.state.CallBackToParent(e.latlng)
    const newMarker = {
      key: 'newMarker',
      position: e.latlng,
      // icon: { iconPerson },
      isDraggable: false,
      opacity: 1,
      callbackFuc: this.state.CallBackToParent,
      formData: {
        markerData: {},
        deleteMarker: this.state.deleteMarker.bind(this),
        moveMarker: this.state.moveMarker.bind(this),
        EditMarker: this.state.EditMarker.bind(this),
        submit: this.addMarkerData.bind(this)
      }
      // children: <MarkerForm markerData={{}} deleteMarker={this.state.deleteMarker.bind(this)} moveMarker={this.state.moveMarker.bind(this)} EditMarker={this.state.EditMarker.bind(this)} submit={this.addMarkerData.bind(this)}/>
    }
    if (markers.filter(x => x.key === 'newMarker').length !== 0) {
      var index = markers.findIndex(x => x.key === 'newMarker')
      markers[index] = newMarker
    } else {
      markers.push(newMarker)
    }

    this.setState({ markers })
  }
  addMarkerData(data) {//GlobalID
    console.log('data', data)
    var tempArray = this.state.markers
    if (data.name) {
      var index = this.state.markers.findIndex(p => p.name === data.name);
      tempArray[index] = {
        ...tempArray[index],
        key: data.name,
        isDraggable: false,
        opacity: 1,
        formData: {
          markerData: data,
          deleteMarker: this.state.deleteMarker.bind(this),
          moveMarker: this.state.moveMarker.bind(this),
          EditMarker: this.state.EditMarker.bind(this),
          submit: this.addMarkerData.bind(this)
        }
        // children: <MarkerForm markerData={data} deleteMarker={this.state.deleteMarker.bind(this)} moveMarker={this.state.moveMarker.bind(this)} EditMarker={this.state.EditMarker.bind(this)} submit={this.addMarkerData.bind(this)}/>
      }
    } else {
      var index = this.state.markers.findIndex(p => p.key === data.GlobalID);
      tempArray[index] = {
        ...tempArray[index],
        key: data.GlobalID,
        name: data.GlobalID,
        isDraggable: false,
        opacity: 1,
        formData: {
          markerData: data,
          deleteMarker: this.state.deleteMarker.bind(this),
          moveMarker: this.state.moveMarker.bind(this),
          EditMarker: this.state.EditMarker.bind(this),
          submit: this.addMarkerData.bind(this)
        }
        // children: <MarkerForm markerData={data} deleteMarker={this.state.deleteMarker.bind(this)} moveMarker={this.state.moveMarker.bind(this)} EditMarker={this.state.EditMarker.bind(this)} submit={this.addMarkerData.bind(this)}/>
      }
    }

    const map = this.mapRef.current.leafletElement;
    console.log(tempArray)
    this.setState({
      markers: tempArray.filter(m => map.getBounds().contains(m.position)),
      originalMarkers: tempArray,
      movingMarker: false
    })
    // this.state.moveMarker(data, true)
  }

  displayMarkers = (e) => {
    // const map = this.mapRef.current.leafletElement;
    // const markers = this.state.originalMarkers.filter(m => map.getBounds().contains(m.position));
    // console.log('getting here', markers, this.state.originalMarkers);
    // this.setState({
    //   markers: markers
    // });
    
  }

  updateMap = () => {
    const b = this.mapRef.current.leafletElement.getBounds();
    console.log('zoomt', this.mapRef.current.leafletElement.getZoom())
    const map = this.mapRef.current.leafletElement;
    const markers = this.state.originalMarkers.filter(m => map.getBounds().contains(m.position));
    console.log('getting here', markers, this.state.originalMarkers);
    this.setState({
      bounds: [
        b.getSouthWest().lng,
        b.getSouthWest().lat,
        b.getNorthEast().lng,
        b.getNorthEast().lat
      ],
      zoom: this.mapRef.current.leafletElement.getZoom(),
      markers: markers
    })
  }

  render() {
    const center = [this.state.lat, this.state.lng];

    return (
      <Map
        ref={this.mapRef}
        onMoveEnd={() => this.updateMap()}
        preferCanvas={false}
        center={center}
        onClick={this.state.showFormAndAddMarker && !this.state.isEditingMarker ? this.addMarker : null}
        zoom={this.state.zoom}
      >
        <TileLayer
          attribution="&amp;copy <a href=&quot;https://osm.org/copyright&quot;>OpenStreetMap</a> contributors"
          url="https://{s}.tile.osm.org/{z}/{x}/{y}.png"
        />
        {this.state.zoom > 9 && <MyMarkersList markers={this.state.markers} />}
      </Map>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/CustomMap.jsx